const checkIndeterminateSelect = (selection, data, keyField) => {
  if (selection && selection.length !== 0 && data) {
    const dataIds = data.map(row => row[keyField]);
    return dataIds.filter(key => !selection.includes(key)).length > 0;
  }
  return false;
};

export default checkIndeterminateSelect;
